module.exports = __webpack_public_path__ + "static/img/propuestas-1.cd2d98a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/propuestas-1.jpg
// module id = eTiu
// module chunks = 1